//generated routes, please don't modify it. use npm run route to regenereate it. 
import { dynamicImport, IRoute } from 'slipstream-components';
const routes: IRoute[] = [
  {
    "path": "/user",
    "component": dynamicImport(() => import(/* webpackChunkName: "UserLayout" */ "slipstream-components/src/layouts/UserLayout/UserLayout")),
    "routes": [
      {
        "path": "/user",
        "exact": true,
        "redirect": "/user/login"
      },
      {
        "path": "/user/login",
        "component": dynamicImport(() => import(/* webpackChunkName: "Login" */ "../plugins/ui-share-rbac/src/pages/Login/Login"))
      }
    ]
  },
  {
    "path": "/",
    "component": dynamicImport(() => import(/* webpackChunkName: "BasicLayout" */ "slipstream-components/src/layouts/BasicLayout/BasicLayout")),
    "routes": [
      {
        "path": "/",
        "exact": true,
        "redirect": "/dashboard"
      },
      {
        "path": "/dashboard",
        "name": "dashboard",
        "icon": "icon_dashboard",
        "component": dynamicImport(() => import(/* webpackChunkName: "Dashboard" */ "../plugins/ui-common/src/pages/Dashboard/Dashboard"))
      },
      {
        "path": "/monitor",
        "name": "monitor",
        "icon": "icon_monitor",
        "routes": [
          {
            "path": "/monitor/monitor-overview",
            "name": "monitor_overview",
            "component": dynamicImport(() => import(/* webpackChunkName: "MonitorOverview" */ "../plugins/ui-monitor/src/pages/Monitor/MonitorOverview")),
            "authority": [
              "SP GeoMap:R",
              "Tenant GeoMap:R"
            ]
          },
          {
            "path": "/monitor/alerts-alarms",
            "name": "alert_alarms",
            "routes": [
              {
                "path": "/monitor/alerts-alarms/alerts",
                "name": "alerts",
                "component": dynamicImport(() => import(/* webpackChunkName: "AlertManagement" */ "../plugins/ui-monitor/src/pages/AlertAlarm/AlertManagement")),
                "authority": [
                  "Alerts:R"
                ]
              },
              {
                "path": "/monitor/alerts-alarms/alarms",
                "name": "alarms",
                "component": dynamicImport(() => import(/* webpackChunkName: "AlarmManagement" */ "../plugins/ui-monitor/src/pages/AlertAlarm/AlarmManagement")),
                "authority": [
                  "Alarms:R"
                ]
              },
              {
                "path": "/monitor/alerts-alarms/sdwan-alert-definition",
                "name": "sdwan_alert_definition",
                "component": dynamicImport(() => import(/* webpackChunkName: "AlertDefinition" */ "../plugins/ui-monitor/src/pages/AlertAlarm/AlertDefinition")),
                "authority": [
                  "Security Alert Definitions:R",
                  "SD-WAN Alert Definitions:R"
                ]
              }
            ]
          },
          {
            "path": "/monitor/link-switch-events",
            "name": "link_switch_events",
            "component": dynamicImport(() => import(/* webpackChunkName: "LinkSwitchMonitor" */ "../plugins/ui-monitor/src/pages/LinkSwitch/LinkSwitchMonitor")),
            "authority": [
              "feature:managed_wan_v2",
              "Link Switch Events:R",
              "platform:pc",
              "feature:sdwan_adv"
            ]
          },
          {
            "path": "/monitor/traffic-logs",
            "name": "traffic_logs",
            "component": dynamicImport(() => import(/* webpackChunkName: "TrafficLogMonitor" */ "../plugins/ui-monitor/src/pages/TrafficLog/TrafficLogMonitor")),
            "authority": [
              "All Events:R"
            ]
          },
          {
            "path": "/monitor/security-events",
            "name": "security_events",
            "routes": [
              {
                "path": "/monitor/security-events/all-events",
                "name": "all_events",
                "component": dynamicImport(() => import(/* webpackChunkName: "AllEvent" */ "../plugins/ui-monitor/src/pages/SecurityEvent/AllEvent")),
                "authority": [
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/firewall",
                "name": "firewall",
                "component": dynamicImport(() => import(/* webpackChunkName: "Firewall" */ "../plugins/ui-monitor/src/pages/SecurityEvent/Firewall")),
                "authority": [
                  "Firewall:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/web-filtering",
                "name": "web_filtering",
                "component": dynamicImport(() => import(/* webpackChunkName: "WebFiltering" */ "../plugins/ui-monitor/src/pages/SecurityEvent/WebFiltering")),
                "authority": [
                  "Web Filtering:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/ipsec-vpn",
                "name": "ipsec_vpn",
                "component": dynamicImport(() => import(/* webpackChunkName: "IpsecVPN" */ "../plugins/ui-monitor/src/pages/SecurityEvent/IpsecVPN")),
                "authority": [
                  "IPSec VPNs:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/content-filtering",
                "name": "content_filtering",
                "component": dynamicImport(() => import(/* webpackChunkName: "ContentFiltering" */ "../plugins/ui-monitor/src/pages/SecurityEvent/ContentFiltering")),
                "authority": [
                  "Content Filtering:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/anti-spam",
                "name": "anti_spam",
                "component": dynamicImport(() => import(/* webpackChunkName: "AntiSpam" */ "../plugins/ui-monitor/src/pages/SecurityEvent/AntiSpam")),
                "authority": [
                  "Antispam:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/anti-virus",
                "name": "anti_virus",
                "component": dynamicImport(() => import(/* webpackChunkName: "AntiVirus" */ "../plugins/ui-monitor/src/pages/SecurityEvent/AntiVirus")),
                "authority": [
                  "Antivirus:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/ips",
                "name": "ips",
                "component": dynamicImport(() => import(/* webpackChunkName: "IPS" */ "../plugins/ui-monitor/src/pages/SecurityEvent/IPS")),
                "authority": [
                  "IPS:R",
                  "All Events:R"
                ]
              },
              {
                "path": "/monitor/security-events/screen",
                "name": "screen",
                "component": dynamicImport(() => import(/* webpackChunkName: "Screen" */ "../plugins/ui-monitor/src/pages/SecurityEvent/Screen")),
                "authority": [
                  "Screen:R",
                  "All Events:R"
                ]
              }
            ]
          },
          {
            "path": "/monitor/sla-performance/app-detail",
            "name": "sla_performance_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "AppSLAPerformanceDetail" */ "../plugins/ui-monitor/src/pages/SLA/AppSLAPerformanceDetail")),
            "authority": [
              "Application SLA Performance:R",
              "Tenants SLA Performance:R"
            ]
          },
          {
            "path": "/monitor/tenant-sla-performance/tenant-sla-performance-detail",
            "name": "tenant_sla_performance_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteSLAPerformance" */ "../plugins/ui-monitor/src/pages/SLA/SiteSLAPerformance")),
            "authority": [
              "Tenants SLA Performance:R"
            ]
          },
          {
            "path": "/monitor/sla-performance/detail",
            "name": "sla_performance_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteSLAPerformanceDetail" */ "../plugins/ui-monitor/src/pages/SLA/SiteSLAPerformanceDetail")),
            "authority": [
              "Application SLA Performance:R",
              "Tenants SLA Performance:R"
            ]
          },
          {
            "path": "/monitor/sla-performance",
            "name": "sla_performance",
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteSLAPerformance" */ "../plugins/ui-monitor/src/pages/SLA/SiteSLAPerformance")),
            "authority": [
              "Application SLA Performance:R",
              "platform:pc",
              "feature:sdwan_adv"
            ]
          },
          {
            "path": "/monitor/tenant-sla-performance",
            "name": "tenant_sla_performance",
            "component": dynamicImport(() => import(/* webpackChunkName: "TenantSLAPerformance" */ "../plugins/ui-monitor/src/pages/SLA/TenantSLAPerformance")),
            "authority": [
              "Tenants SLA Performance:R"
            ]
          },
          {
            "path": "/monitor/app-visibility",
            "name": "app_visibility",
            "component": dynamicImport(() => import(/* webpackChunkName: "AppVisibility" */ "../plugins/ui-monitor/src/pages/AppVisibility/AppVisibility")),
            "authority": [
              "Application Visibility:R"
            ]
          },
          {
            "path": "/monitor/user-visibility",
            "name": "user_visibility",
            "component": dynamicImport(() => import(/* webpackChunkName: "UserVisibility" */ "../plugins/ui-monitor/src/pages/UserVisibility/UserVisibility")),
            "authority": [
              "Application Visibility:R"
            ]
          },
          {
            "path": "/monitor/threat_map_live",
            "name": "threat_map_live",
            "component": dynamicImport(() => import(/* webpackChunkName: "ThreatMap" */ "../plugins/ui-monitor/src/pages/ThreatMap/ThreatMap")),
            "authority": [
              "All Events:R",
              "Threat Map (Live):R"
            ]
          },
          {
            "path": "/monitor/jobs",
            "name": "jobs",
            "component": dynamicImport(() => import(/* webpackChunkName: "JobPages" */ "../plugins/ui-monitor/src/pages/Job/JobPages")),
            "authority": [
              "Job:R"
            ]
          }
        ]
      },
      {
        "path": "/resource",
        "name": "resource",
        "icon": "icon_resource",
        "routes": [
          {
            "path": "/resource/site-management/site-management-subpages",
            "name": "site_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteSubPage" */ "../plugins/ui-resource/src/pages/Site/SiteSubPage")),
            "authority": [
              "Site Management:R"
            ]
          },
          {
            "path": "/resource/site-management/configure-site",
            "name": "configure_site",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "ConfigureSitePage" */ "../plugins/ui-resource/src/pages/Site/ConfigureSitePage")),
            "authority": [
              "Site Management:C"
            ]
          },
          {
            "path": "/resource/devices/hub-devices/create-hub-device",
            "name": "create_hub_device",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "CreateHubDevice" */ "../plugins/ui-resource/src/pages/Site/CreateSite/CreateHubDevice")),
            "authority": [
              "CloudHubDevices:C"
            ]
          },
          {
            "path": "/resource/site-management/site-create-using-template",
            "name": "site_create_using_template",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteCreateUsingTemplate" */ "../plugins/ui-resource/src/pages/Site/SiteCreateUsingTemplate")),
            "authority": [
              "Site Management:R"
            ]
          },
          {
            "path": "/resource/devices/tenant-devices/tenant-device-subpages",
            "name": "device_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "DeviceSubPage" */ "../plugins/ui-resource/src/pages/Device/DeviceSubPage")),
            "authority": [
              "TenantDevices:R"
            ]
          },
          {
            "path": "/resource/cpe-devices/cpe-device-subpages",
            "name": "device_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "DeviceSubPage" */ "../plugins/ui-resource/src/pages/Device/DeviceSubPage")),
            "authority": [
              "Devices:R"
            ]
          },
          {
            "path": "/resource/devices/hub-devices/hub-device-subpages",
            "name": "hub_device_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "HubDeviceSubPage" */ "../plugins/ui-resource/src/pages/Device/HubDeviceSubPage")),
            "authority": [
              "CloudHubDevices:R"
            ]
          },
          {
            "path": "/resource/devices/router-devices/router-device-subpages",
            "name": "router_device_detail",
            "hidden": true
          },
          {
            "path": "/resource/templates/configuration-templates/create_config_template",
            "name": "create_config_template",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "CreateConfigTemplateInPage" */ "../plugins/ui-share-config-template/src/pages/ConfigTemplate/CreateConfigTemplate/CreateConfigTemplateInPage")),
            "authority": [
              "ConfigurationTemplates:C"
            ]
          },
          {
            "path": "/resource/templates/configuration-templates/edit_config_template",
            "name": "edit_config_template",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "CreateConfigTemplateInPage" */ "../plugins/ui-share-config-template/src/pages/ConfigTemplate/CreateConfigTemplate/CreateConfigTemplateInPage")),
            "authority": [
              "ConfigurationTemplates:U"
            ]
          },
          {
            "path": "/resource/templates/configuration-templates/deploy_config_template",
            "name": "deploy_config_template",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "DeployToDevicesInPage" */ "../plugins/ui-share-config-template/src/pages/ConfigTemplate/DeployConfigTemplate/DeployToDevicesInPage")),
            "authority": [
              "ConfigurationTemplates:DeployToDevices"
            ]
          },
          {
            "path": "/resource/site-management",
            "name": "site_management",
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteManagement" */ "../plugins/ui-resource/src/pages/Site/SiteManagement")),
            "authority": [
              "Site Management:R"
            ]
          },
          {
            "path": "/resource/cpe-devices",
            "name": "devices",
            "component": dynamicImport(() => import(/* webpackChunkName: "CpeDeviceManagement" */ "../plugins/ui-resource/src/pages/Device/CpeDeviceManagement")),
            "authority": [
              "Devices:R"
            ]
          },
          {
            "path": "/resource/site-groups",
            "name": "site_groups",
            "component": dynamicImport(() => import(/* webpackChunkName: "SiteGroupManagement" */ "../plugins/ui-resource/src/pages/SiteGroup/SiteGroupManagement")),
            "authority": [
              "Site Groups:R"
            ]
          },
          {
            "path": "/resource/mesh-tags",
            "name": "mesh_tags",
            "component": dynamicImport(() => import(/* webpackChunkName: "MeshTagManagement" */ "../plugins/ui-resource/src/pages/MeshTag/MeshTagManagement")),
            "authority": [
              "feature:mesh",
              "Mesh Tags:R"
            ]
          },
          {
            "path": "/resource/pops",
            "name": "pop_management",
            "component": dynamicImport(() => import(/* webpackChunkName: "POPManagement" */ "../plugins/ui-resource/src/pages/POP/POPManagement")),
            "authority": [
              "PoPs:R"
            ]
          },
          {
            "path": "/resource/devices/tenant-devices",
            "name": "devices.tenant_devices",
            "component": dynamicImport(() => import(/* webpackChunkName: "CpeDeviceManagement" */ "../plugins/ui-resource/src/pages/Device/CpeDeviceManagement")),
            "authority": [
              "TenantDevices:R"
            ]
          },
          {
            "path": "/resource/devices/hub-devices",
            "name": "devices.hub_devices",
            "component": dynamicImport(() => import(/* webpackChunkName: "CloudHubDeviceManagement" */ "../plugins/ui-resource/src/pages/Device/CloudHubDeviceManagement")),
            "authority": [
              "CloudHubDevices:R"
            ]
          },
          {
            "path": "/resource/templates",
            "name": "templates",
            "routes": [
              {
                "path": "/resource/templates/site-templates",
                "name": "site_template",
                "component": dynamicImport(() => import(/* webpackChunkName: "SiteTemplateManagement" */ "../plugins/ui-resource/src/pages/SiteTemplate/SiteTemplateManagement")),
                "authority": [
                  "Site Templates:R"
                ]
              },
              {
                "path": "/resource/templates/device-templates",
                "name": "device_templates",
                "component": dynamicImport(() => import(/* webpackChunkName: "DeviceTemplateManagement" */ "../plugins/ui-resource/src/pages/DeviceTemplate/DeviceTemplateManagement")),
                "authority": [
                  "DeviceTemplates:R"
                ]
              },
              {
                "path": "/resource/templates/configuration-templates",
                "name": "configuration_templates",
                "component": dynamicImport(() => import(/* webpackChunkName: "ConfigTemplateManagement" */ "../plugins/ui-resource/src/pages/ConfigTemplate/ConfigTemplateManagement")),
                "authority": [
                  "ConfigurationTemplates:R"
                ]
              }
            ]
          },
          {
            "path": "/resource/images",
            "name": "images",
            "component": dynamicImport(() => import(/* webpackChunkName: "ImageManagement" */ "../plugins/ui-resource/src/pages/Image/ImageManagement")),
            "authority": [
              "Images:R"
            ]
          },
          {
            "path": "/resource/workflow-management",
            "name": "workflow_management"
          }
        ]
      },
      {
        "path": "/configuration",
        "name": "configuration",
        "icon": "icon_configuration",
        "routes": [
          {
            "path": "/configuration/firewall",
            "name": "firewall",
            "routes": [
              {
                "path": "/configuration/firewall/firewall-policies/FirewallPolicyIntent",
                "name": "firewall_policy_intents",
                "hidden": true,
                "component": dynamicImport(() => import(/* webpackChunkName: "FirewallPolicyIntent" */ "../plugins/ui-configuration/src/pages/Firewall/FirewallPolicyIntent")),
                "authority": [
                  "FirewallPolicy:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/firewall/firewall-policies",
                "name": "firewall_policies",
                "component": dynamicImport(() => import(/* webpackChunkName: "FirewallPolicy" */ "../plugins/ui-configuration/src/pages/Firewall/FirewallPolicy")),
                "authority": [
                  "FirewallPolicy:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/firewall/schedules",
                "name": "schedules",
                "component": dynamicImport(() => import(/* webpackChunkName: "FirewallSchedule" */ "../plugins/ui-configuration/src/pages/Firewall/FirewallSchedule")),
                "authority": [
                  "Schedule:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/firewall/default-settings",
                "name": "default_settings",
                "component": dynamicImport(() => import(/* webpackChunkName: "DefaultSetting" */ "../plugins/ui-configuration/src/pages/Firewall/DefaultSetting")),
                "authority": [
                  "FirewallPolicy:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/unified-threat-management",
            "name": "utm",
            "routes": [
              {
                "path": "/configuration/unified-threat-management/utm-profiles",
                "name": "utm_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "UtmProfile" */ "../plugins/ui-configuration/src/pages/UTM/UtmProfile")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/utm-settings",
                "name": "utm_settings",
                "component": dynamicImport(() => import(/* webpackChunkName: "UtmSetting" */ "../plugins/ui-configuration/src/pages/UTM/UtmSetting")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/web-filter-profiles",
                "name": "web_filter_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "WebFilterProfile" */ "../plugins/ui-configuration/src/pages/UTM/WebFilterProfile")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/antivirus-profiles",
                "name": "antivirus_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "AntiVirusProfile" */ "../plugins/ui-configuration/src/pages/UTM/AntiVirusProfile")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/antispam-profiles",
                "name": "antispam_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "AntiSpamProfile" */ "../plugins/ui-configuration/src/pages/UTM/AntiSpamProfile")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/content-filtering-profiles",
                "name": "content_filtering_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "ContentFilterProfile" */ "../plugins/ui-configuration/src/pages/UTM/ContentFilterProfile")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/url-patterns",
                "name": "url_patterns",
                "component": dynamicImport(() => import(/* webpackChunkName: "UrlPattern" */ "../plugins/ui-configuration/src/pages/UTM/UrlPattern")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/unified-threat-management/url-categories",
                "name": "url_categories",
                "component": dynamicImport(() => import(/* webpackChunkName: "UrlCategory" */ "../plugins/ui-configuration/src/pages/UTM/UrlCategory")),
                "authority": [
                  "UTM:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/nat",
            "name": "nat",
            "routes": [
              {
                "path": "/configuration/nat/nat-policies/NATPolicyIntent",
                "name": "nat_policy_intents",
                "hidden": true,
                "component": dynamicImport(() => import(/* webpackChunkName: "NATPolicyIntent" */ "../plugins/ui-configuration/src/pages/NAT/NATPolicyIntent")),
                "authority": [
                  "NAT:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/nat/nat-policies",
                "name": "nat_policies",
                "component": dynamicImport(() => import(/* webpackChunkName: "NATPolicy" */ "../plugins/ui-configuration/src/pages/NAT/NATPolicy")),
                "authority": [
                  "NAT:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/nat/pools",
                "name": "pools",
                "component": dynamicImport(() => import(/* webpackChunkName: "NATPools" */ "../plugins/ui-configuration/src/pages/NAT/NATPools")),
                "authority": [
                  "NAT:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/ips",
            "name": "ips",
            "routes": [
              {
                "path": "/configuration/ips/ips-profiles/ips-rules",
                "name": "ips_rules",
                "hidden": true,
                "component": dynamicImport(() => import(/* webpackChunkName: "IPSRules" */ "../plugins/ui-configuration/src/pages/IPS/IPSRules")),
                "authority": [
                  "IPS:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/ips/ips-profiles",
                "name": "ips_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "IPSProfile" */ "../plugins/ui-configuration/src/pages/IPS/IPSProfile")),
                "authority": [
                  "IPS:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/ips/ips-signatures",
                "name": "ips_signatures",
                "component": dynamicImport(() => import(/* webpackChunkName: "IPSSignature" */ "../plugins/ui-configuration/src/pages/IPS/IPSSignature")),
                "authority": [
                  "IPS:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/ssl-proxy",
            "name": "ssl_proxy",
            "routes": [
              {
                "path": "/configuration/ssl-proxy/policy",
                "name": "policy",
                "component": dynamicImport(() => import(/* webpackChunkName: "SSLPolicy" */ "../plugins/ui-configuration/src/pages/SSLProxy/SSLPolicy")),
                "authority": [
                  "SSL Policy:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/ssl-proxy/profiles",
                "name": "profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "Profile" */ "../plugins/ui-configuration/src/pages/SSLProxy/Profile")),
                "authority": [
                  "SSL Policy:R",
                  "FirewallPolicy:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/sdwan",
            "name": "sdwan",
            "routes": [
              {
                "path": "/configuration/sdwan/sdwan-policies",
                "name": "sdwan_policies",
                "component": dynamicImport(() => import(/* webpackChunkName: "SDWANPolicy" */ "../plugins/ui-configuration/src/pages/SDWAN/SDWANPolicy")),
                "authority": [
                  "SD-WAN Policy:R",
                  "feature:managed_wan_v2",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/sdwan/sla-profiles",
                "name": "sla_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "SlaProfileManagement" */ "../plugins/ui-configuration/src/pages/SlaProfile/SlaProfileManagement")),
                "authority": [
                  "Tenant SLA Based Steering Profiles:R",
                  "platform:pc",
                  "feature:sdwan_adv"
                ]
              },
              {
                "path": "/configuration/sdwan/path-profiles",
                "name": "path_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "PathProfileManagement" */ "../plugins/ui-configuration/src/pages/PathProfile/PathProfileManagement")),
                "authority": [
                  "Tenant Path Based Steering Profiles:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/sdwan/breakout-profiles",
                "name": "breakout_profiles",
                "component": dynamicImport(() => import(/* webpackChunkName: "BreakoutPages" */ "../plugins/ui-configuration/src/pages/BreakoutProfile/BreakoutPages")),
                "authority": [
                  "Cloud Breakout Profiles:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/sdlan",
            "name": "sdlan",
            "routes": [
              {
                "path": "/configuration/sdlan/port-profile-management",
                "name": "port_profile_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "PortProfileManagement" */ "../plugins/ui-configuration/src/pages/SDLAN/PortProfile/PortProfileManagement")),
                "authority": [
                  "Port Profiles:R",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/sdlan/authentication-profile-management",
                "name": "authentication_profile_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "AuthenticationProfileManagement" */ "../plugins/ui-configuration/src/pages/SDLAN/AuthenticationProfile/AuthenticationProfileManagement")),
                "authority": [
                  "SD-WAN Policy:R",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/sdlan/firewall-filter-management/FirewallFilterRules",
                "name": "firewall_filter_rules",
                "hidden": true,
                "component": dynamicImport(() => import(/* webpackChunkName: "FirewallFilterRules" */ "../plugins/ui-configuration/src/pages/SDLAN/FirewallFilter/FirewallFilterRules")),
                "authority": [
                  "Firewall Filters:R",
                  "platform:pc",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/sdlan/firewall-filter-management",
                "name": "firewall_filter_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "FirewallFilterManagement" */ "../plugins/ui-configuration/src/pages/SDLAN/FirewallFilter/FirewallFilterManagement")),
                "authority": [
                  "Firewall Filters:R",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/sdlan/access-profile-management",
                "name": "access_profile_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "AccessProfileManagement" */ "../plugins/ui-configuration/src/pages/SDLAN/AccessProfile/AccessProfileManagement")),
                "authority": [
                  "Access Profiles:R",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/sdlan/radius-server-profile-management",
                "name": "radius_server_profile_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "RadiusServerProfileManagement" */ "../plugins/ui-configuration/src/pages/SDLAN/RADIUSServerProfile/RadiusServerProfileManagement")),
                "authority": [
                  "RADIUS Server Profiles:R",
                  "feature:ex_lan_device"
                ]
              }
            ]
          },
          {
            "path": "/configuration/sla-profiles",
            "name": "sla_profiles",
            "component": dynamicImport(() => import(/* webpackChunkName: "SlaProfileManagement" */ "../plugins/ui-configuration/src/pages/SlaProfile/SlaProfileManagement")),
            "authority": [
              "Application SLA Profiles:R",
              "SLA Based Steering Profiles:R",
              "platform:pc"
            ]
          },
          {
            "path": "/configuration/path-profiles",
            "name": "path_profiles",
            "component": dynamicImport(() => import(/* webpackChunkName: "PathProfileManagement" */ "../plugins/ui-configuration/src/pages/PathProfile/PathProfileManagement")),
            "authority": [
              "Application SLA Profiles:R",
              "Path Based Steering Profiles:R",
              "platform:pc"
            ]
          },
          {
            "path": "/configuration/traffic-types",
            "name": "traffic_types",
            "component": dynamicImport(() => import(/* webpackChunkName: "TrafficTypeManagement" */ "../plugins/ui-configuration/src/pages/TrafficType/TrafficTypeManagement")),
            "authority": [
              "Application Traffic Type Profiles:R",
              "platform:pc"
            ]
          },
          {
            "path": "/configuration/breakout-profiles",
            "name": "breakout_profiles",
            "component": dynamicImport(() => import(/* webpackChunkName: "BreakoutProfileManagement" */ "../plugins/ui-configuration/src/pages/BreakoutProfile/BreakoutProfileManagement")),
            "authority": [
              "SD-WAN Breakout Profiles:R",
              "platform:pc"
            ]
          },
          {
            "path": "/configuration/application-signatures",
            "name": "application_signatures",
            "component": dynamicImport(() => import(/* webpackChunkName: "ApplicationSignatureManagement" */ "../plugins/ui-configuration/src/pages/ApplicationSignature/ApplicationSignatureManagement")),
            "authority": [
              "AppSignature:R",
              "feature:SP",
              "feature:OpCo",
              "platform:pc"
            ]
          },
          {
            "path": "/configuration/shared-objects",
            "name": "shared_objects",
            "routes": [
              {
                "path": "/configuration/shared-objects/addresses",
                "name": "addresses",
                "component": dynamicImport(() => import(/* webpackChunkName: "AddressManagement" */ "../plugins/ui-configuration/src/pages/Addresses/AddressManagement")),
                "authority": [
                  "Address:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/shared-objects/services",
                "name": "services",
                "component": dynamicImport(() => import(/* webpackChunkName: "ServicesManagement" */ "../plugins/ui-configuration/src/pages/Services/ServicesManagement")),
                "authority": [
                  "Service:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/shared-objects/departments",
                "name": "departments",
                "component": dynamicImport(() => import(/* webpackChunkName: "DepartmentsManagement" */ "../plugins/ui-configuration/src/pages/Departments/DepartmentsManagement")),
                "authority": [
                  "Department:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/shared-objects/application-signatures",
                "name": "application_signatures",
                "component": dynamicImport(() => import(/* webpackChunkName: "ApplicationSignatureManagement" */ "../plugins/ui-configuration/src/pages/ApplicationSignature/ApplicationSignatureManagement")),
                "authority": [
                  "AppSignature:R",
                  "feature:Enterprise",
                  "platform:pc"
                ]
              },
              {
                "path": "/configuration/shared-objects/mac",
                "name": "mac",
                "component": dynamicImport(() => import(/* webpackChunkName: "MACManagement" */ "../plugins/ui-configuration/src/pages/MAC/MACManagement")),
                "authority": [
                  "MAC:R",
                  "platform:pc",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/shared-objects/ports",
                "name": "ports",
                "component": dynamicImport(() => import(/* webpackChunkName: "PortManagement" */ "../plugins/ui-configuration/src/pages/Ports/PortManagement")),
                "authority": [
                  "Port:R",
                  "platform:pc",
                  "feature:ex_lan_device"
                ]
              },
              {
                "path": "/configuration/shared-objects/protocols",
                "name": "protocols",
                "component": dynamicImport(() => import(/* webpackChunkName: "ProtocolManagement" */ "../plugins/ui-configuration/src/pages/Protocols/ProtocolManagement")),
                "authority": [
                  "Protocol:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/configuration/network-services/network-service-subpages",
            "name": "network_service_detail",
            "hidden": true,
            "component": dynamicImport(() => import(/* webpackChunkName: "NetworkServicesSubPage" */ "../plugins/ui-configuration/src/pages/NetworkService/NetworkServicesSubPage")),
            "authority": [
              "Network Services:R"
            ]
          },
          {
            "path": "/configuration/network-services",
            "name": "network_services",
            "component": dynamicImport(() => import(/* webpackChunkName: "NetworkServiceManagement" */ "../plugins/ui-configuration/src/pages/NetworkService/NetworkServiceManagement")),
            "authority": [
              "Network Services:R",
              "platform:pc"
            ]
          }
        ]
      },
      {
        "path": "/tenant",
        "name": "tenant",
        "icon": "icon_tenant",
        "routes": [
          {
            "path": "/tenant/tenant-management",
            "name": "tenant_management",
            "component": dynamicImport(() => import(/* webpackChunkName: "TenantManagement" */ "../plugins/ui-tenant/src/pages/Tenant/TenantManagement")),
            "authority": [
              "Tenants:R"
            ]
          },
          {
            "path": "/tenant/operating-companies",
            "name": "operating_companies",
            "component": dynamicImport(() => import(/* webpackChunkName: "OpCoManagement" */ "../plugins/ui-tenant/src/pages/OpCo/OpCoManagement")),
            "authority": [
              "OpCos:R"
            ]
          }
        ]
      },
      {
        "path": "/report",
        "name": "report",
        "icon": "icon_report",
        "routes": [
          {
            "path": "/report/report-definitions",
            "name": "report_definitions",
            "routes": [
              {
                "path": "/report/report-definitions/security-definition",
                "name": "security_definition",
                "component": dynamicImport(() => import(/* webpackChunkName: "SecurityReportDefinitionManagement" */ "../plugins/ui-report/src/pages/ReportDefinition/SecurityReportDefinitionManagement")),
                "authority": [
                  "Report Definitions Security:R"
                ]
              },
              {
                "path": "/report/report-definitions/sdwan-definition",
                "name": "sdwan_definition",
                "component": dynamicImport(() => import(/* webpackChunkName: "SDWanReportDefinitionManagement" */ "../plugins/ui-report/src/pages/ReportDefinition/SDWanReportDefinitionManagement")),
                "authority": [
                  "Report Definitions SD-WAN:R",
                  "feature:managed_wan_v2"
                ]
              }
            ]
          },
          {
            "path": "/report/generated-reports",
            "name": "generated_reports",
            "routes": [
              {
                "path": "/report/generated-reports/security-report",
                "name": "security_report",
                "component": dynamicImport(() => import(/* webpackChunkName: "GeneratedSecurityReport" */ "../plugins/ui-report/src/pages/GeneratedReport/GeneratedSecurityReport")),
                "authority": [
                  "Generated Reports Security:R"
                ]
              },
              {
                "path": "/report/generated-reports/sdwan-report",
                "name": "sdwan_report",
                "component": dynamicImport(() => import(/* webpackChunkName: "GeneratedSDWanReport" */ "../plugins/ui-report/src/pages/GeneratedReport/GeneratedSDWanReport")),
                "authority": [
                  "Generated Reports SD-WAN:R",
                  "feature:managed_wan_v2"
                ]
              }
            ]
          }
        ]
      },
      {
        "path": "/administration",
        "name": "administration",
        "icon": "icon_administration",
        "routes": [
          {
            "path": "/administration/profile",
            "name": "my_profile",
            "component": dynamicImport(() => import(/* webpackChunkName: "MyProfile" */ "../plugins/ui-administration/src/pages/MyProfile/MyProfile")),
            "authority": [
              "ReadLocalUser",
              "ReadSamlUser"
            ]
          },
          {
            "path": "/administration/authentication",
            "name": "authentication",
            "component": dynamicImport(() => import(/* webpackChunkName: "AuthenticationManagement" */ "../plugins/ui-administration/src/pages/Authentication/AuthenticationManagement")),
            "authority": [
              "Authentication:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/two-factor-authentication",
            "name": "two_factor_authentication"
          },
          {
            "path": "/administration/users",
            "name": "users",
            "component": dynamicImport(() => import(/* webpackChunkName: "UserManagement" */ "../plugins/ui-share-rbac/src/pages/User/UserManagement")),
            "authority": [
              "ReadLocalUser",
              "ReadSamlUser",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/roles",
            "name": "roles",
            "component": dynamicImport(() => import(/* webpackChunkName: "RoleManagement" */ "../plugins/ui-share-rbac/src/pages/Role/RoleManagement")),
            "authority": [
              "Roles:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/audit-logs",
            "name": "audit_logs",
            "component": dynamicImport(() => import(/* webpackChunkName: "AuditLogManagement" */ "../plugins/ui-administration/src/pages/AuditLog/AuditLogManagement")),
            "authority": [
              "AuditLogs:R"
            ]
          },
          {
            "path": "/administration/dynamic-vpn",
            "name": "dynamic_vpn",
            "component": dynamicImport(() => import(/* webpackChunkName: "DynamicVPNManagement" */ "../plugins/ui-administration/src/pages/DynamicVPN/DynamicVPNManagement")),
            "authority": [
              "DynamicVpn:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/license",
            "name": "license",
            "routes": [
              {
                "path": "/administration/license/device-licenses",
                "name": "device_licenses",
                "component": dynamicImport(() => import(/* webpackChunkName: "DeviceLicenseManagement" */ "../plugins/ui-administration/src/pages/DeviceLicense/DeviceLicenseManagement")),
                "authority": [
                  "Device Licenses:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/administration/license/cso-licenses",
                "name": "cso_licenses",
                "component": dynamicImport(() => import(/* webpackChunkName: "CsoLicenseManagement" */ "../plugins/ui-administration/src/pages/CsoLicense/CsoLicenseManagement")),
                "authority": [
                  "CSO Licenses:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/administration/tenant-settings",
            "name": "tenant_settings",
            "component": dynamicImport(() => import(/* webpackChunkName: "TenantSettings" */ "../plugins/ui-administration/src/pages/TenantSettings/TenantSettings")),
            "authority": [
              "TenantSetting:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/global-settings",
            "name": "global_settings",
            "component": dynamicImport(() => import(/* webpackChunkName: "GlobalSettings" */ "../plugins/ui-administration/src/pages/GlobalSettings/GlobalSettings")),
            "authority": [
              "GlobalSetting:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/opco-settings",
            "name": "opco_settings",
            "component": dynamicImport(() => import(/* webpackChunkName: "OpCoSettings" */ "../plugins/ui-administration/src/pages/OpCoSettings/OpCoSettings")),
            "authority": [
              "OpCoSetting:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/signature-database",
            "name": "signature_database",
            "component": dynamicImport(() => import(/* webpackChunkName: "SignatureDatabaseManagement" */ "../plugins/ui-administration/src/pages/SignatureDatabase/SignatureDatabaseManagement")),
            "authority": [
              "SignatureDatabase:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/signature-database-tenant",
            "name": "signature_database",
            "component": dynamicImport(() => import(/* webpackChunkName: "TenantSignatureDatabaseManagement" */ "../plugins/ui-administration/src/pages/SignatureDatabase/TenantSignatureDatabaseManagement")),
            "authority": [
              "Tenant SignatureDatabase:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/certificate",
            "name": "certificate",
            "routes": [
              {
                "path": "/administration/certificate/certification-management",
                "name": "certificate_management",
                "component": dynamicImport(() => import(/* webpackChunkName: "CertificateManagement" */ "../plugins/ui-administration/src/pages/Certificate/CertificateManagement")),
                "authority": [
                  "Certificates:R",
                  "platform:pc"
                ]
              },
              {
                "path": "/administration/certificate/vpn-authentication",
                "name": "vpn_authentication",
                "component": dynamicImport(() => import(/* webpackChunkName: "VPNAuthenticationManagement" */ "../plugins/ui-administration/src/pages/VPNAuthentication/VPNAuthenticationManagement")),
                "authority": [
                  "prop:vpn_auth:pki",
                  "VPN Authentication:R",
                  "platform:pc"
                ]
              }
            ]
          },
          {
            "path": "/administration/identity-management",
            "name": "identity_management",
            "component": dynamicImport(() => import(/* webpackChunkName: "IdentityManagement" */ "../plugins/ui-administration/src/pages/IdentityManagement/IdentityManagement")),
            "authority": [
              "Identity Management:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/ipv6",
            "name": "ipv6",
            "component": dynamicImport(() => import(/* webpackChunkName: "IPV6Management" */ "../plugins/ui-administration/src/pages/IPV6/IPV6Management")),
            "authority": [
              "MAPE:R"
            ]
          },
          {
            "path": "/administration/smtp",
            "name": "smtp",
            "component": dynamicImport(() => import(/* webpackChunkName: "SMTPManagement" */ "../plugins/ui-administration/src/pages/SMTP/SMTPManagement")),
            "authority": [
              "SMTP:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/terms-of-use",
            "name": "terms_of_use",
            "component": dynamicImport(() => import(/* webpackChunkName: "TermsOfUse" */ "../plugins/ui-administration/src/pages/TermsOfUse/TermsOfUse")),
            "authority": [
              "TermsofUse:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/email-templates",
            "name": "email_templates",
            "component": dynamicImport(() => import(/* webpackChunkName: "EmailTemplateManagement" */ "../plugins/ui-administration/src/pages/EmailTemplate/EmailTemplateManagement")),
            "authority": [
              "EmailTemplates:R",
              "platform:pc"
            ]
          },
          {
            "path": "/administration/display-preferences",
            "name": "display_preferences",
            "component": dynamicImport(() => import(/* webpackChunkName: "DisplayPreference" */ "../plugins/ui-administration/src/pages/DisplayPreference/DisplayPreference")),
            "authority": [
              "Preferences:R",
              "platform:pc"
            ]
          }
        ]
      }
    ]
  }
];
export default routes;